module.exports = __webpack_public_path__ + "img/76310.e3e0d86e.svg";